import React from 'react';

import { TabsTrigger } from 'shadcn/components/ui/Tabs';

/**
 * Reusable tab button component with consistent styling
 */
export function TabButton({ children, value }) {
    return (
        <TabsTrigger
            value={value}
            className="font-semibold text-gray-900 rounded-sm border-2 bg-gray-100 data-[state=active]:bg-white px-5 py-1.5 shadow-none"
        >
            {children}
        </TabsTrigger>
    );
}
